import * as React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { MarketTemplate } from "../../../../data";
import { prepareEmptyMarket } from "../../../../helpers";
import { BetButtonsWrapLiveOutright } from "../BetButtonsWrapLiveOutright";
export const MarketsWrapLiveOutright = observer((props) => {
    const market = props.details.markets && props.details.markets.length > 0
        ? toJS(props.details.markets[0])
        : prepareEmptyMarket(props.details.event.id, MarketTemplate.ThreeBox, 0);
    market.template = MarketTemplate.ThreeBox; // this should be done in the parser  !!!!
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__buttons-holder`, "data-uat": `div-ev-list-${props.componentPrefix}-buttons-holder` },
        React.createElement(BetButtonsWrapLiveOutright, { details: props.details, market: market, componentPrefix: props.componentPrefix })));
});
//# sourceMappingURL=MarketsWrapLiveOutright.js.map